module.exports = __webpack_public_path__ + "images/about-banner.1f6bc67.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/image/about-banner.png
// module id = 631
// module chunks = 0